export default __webpack_public_path__ + "static/regular-cabin-bathroom-00c8fad0b554fd388e1f86bce8447489.jpg";